
const ImpactFooter = require('./impact/script');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-impact-footer]', function () {
		new ImpactFooter($(this));
	});
});
